import React from 'react'

import WhyChooseUs from './WhyChooseUs'

import Product from './Product'

import Header from './Header'
import Footer from './Footer'
import Navbar from './Navbar'
import Hero from './Hero'
import Rating from './Rating'
import Maintan from'./Maintan'
import Supply from './Supply'


const Home = () => {
  return (
<>
<Header/>
<Navbar/>
<Hero/>
<Rating/>
<WhyChooseUs/>
<Maintan/>

<Product/>
<Supply/>

<Footer/>


</>
  )
}

export default Home;